(() => {
  angular
    .module('finance')
    .controller(
      'createNetSuiteTransactionCategoryItemAccountCode',
      CreateNetSuiteTransactionCategoryItemAccountCodeController
    );

  CreateNetSuiteTransactionCategoryItemAccountCodeController.$inject = [
    'abp.services.finance.netSuite',
    '$scope',
    '$uibModalInstance',
  ];

  function CreateNetSuiteTransactionCategoryItemAccountCodeController(
    netSuiteSvc,
    $scope,
    $uibModalInstance
  ) {
    const vm = this;

    vm.saving = 0;

    vm.save = save;
    vm.cancel = cancel;

    function save() {
      const isValid = App.isFormValid($scope.createTransactionCategoryItemAccountCode);
      if (isValid) 
        createTransactionCategoryItemAccountCode();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function createTransactionCategoryItemAccountCode() {
      vm.saving += 1;
      netSuiteSvc
        .createTransactionCategoryItemAccountCode(vm.transactionCategoryItemAccountCode)
        .finally(() => {
          $uibModalInstance.close();
          vm.saving -= 1;
        });
    }
  }
})();
